export default {
  methods: {
    changePasswordVisibility() {
      this.passwordVisibility = !this.passwordVisibility;
    },
  },
  computed: {
    passwordFieldType() {
      return this.passwordVisibility ? 'text' : 'password';
    },
    iconForPasswordField() {
      return this.$data.passwordVisibility ? 'mdi-eye' : 'mdi-eye-off';
    },
  },
};
